import MinChildrenDirective from "@/directives/dom/MinChildrenDirective"

export default {
    install(Vue) {
        Vue.directive("MinChildren", MinChildrenDirective)
    },
}
